import Header from "./components/Header";
import Hero from "./components/Hero";
import HotList from "./components/HotList";
import Topics from "./components/Topics";
import SceneSection from "./components/SceneSection";
import EvidenceSection from "./components/EvidenceSection";
import Archive from "./components/Archive";
import About from "./components/About";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Header />
      <Hero />
      <HotList />
      <Topics />
      <SceneSection />
      <EvidenceSection />
      <Archive />
      <About />
      <Faq />
      <Contact />
      <Footer />
    </main>
  );
}